import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-footer',
	templateUrl:'./WaPageFooterProPage.html',
	styles: [],
	styleUrls:['./WaPageFooterProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageFooterProPage
{
	mdContent_400 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageFooter;
\`\`\``;
	mdContent_401 = `\`\`\`java
new WaPageFooter<>()
\`\`\``;
}
